export default "__VITE_ASSET__8b9c187b__"